import { SocialChannel } from '@foodfluence/shared';
import { FaInstagram, FaTiktok } from 'react-icons/fa';

/**
 * Gets channel display name
 */
export const getChannelDisplayName = (channel: SocialChannel): string => {
  switch (channel) {
    case 'instagramPosts': return 'Instagram Feed';
    case 'instagramReels': return 'Instagram Reels';
    case 'instagramStories': return 'Instagram Stories';
    case 'tiktoks': return 'TikTok';
    default: return channel;
  }
};

/**
 * Gets channel icon component
 */
export const getChannelIcon = (channel: SocialChannel) => {
  switch (channel) {
    case 'instagramPosts':
    case 'instagramReels':
    case 'instagramStories':
      return FaInstagram;
    case 'tiktoks':
      return FaTiktok;
    default:
      return FaInstagram;
  }
};

/**
 * Maps social channels to their corresponding deliverable types
 */
export const getChannelDeliverableMap = (): Record<SocialChannel, string> => ({
  instagramPosts: 'instagramPosts',
  tiktoks: 'tiktoks',
  instagramReels: 'instagramReels',
  instagramStories: 'instagramStories'
}); 